import React from 'react'

import CheckLoginDialog from './CheckLoginDialog'
import LoginDialog from '../../store/loginDialog'

export const LoginDialogWithStore = ({}) => {
	const { isOpenLoginDialog, closeLoginDialog } = LoginDialog()
	return <CheckLoginDialog onClose={closeLoginDialog} open={isOpenLoginDialog} />
}
